export default function () {
    'worklet';
}
